(() => {
  const availability = 'filter.v.availability';
  const preferenceKey = 'kt-collection-availability';
  const isCollection = (url) => /^\/collections\/[^/]+\/?$/.test(url.pathname);
  const remember = (showAll) => {
    try { sessionStorage.setItem(preferenceKey, showAll ? 'all' : 'available'); } catch (_) { /* Storage is optional. */ }
  };
  const ensureAvailability = () => {
    if (window.Shopify?.designMode) return;
    const url = new URL(window.location.href);
    if (!isCollection(url) || url.searchParams.has(availability)) return;
    try { if (sessionStorage.getItem(preferenceKey) === 'all') return; } catch (_) { /* Use the default. */ }
    url.searchParams.set(availability, '1');
    url.searchParams.delete('page');
    window.location.replace(url.href);
  };

  if (!window.ktCollectionStockInitialized) {
    window.ktCollectionStockInitialized = true;
    document.addEventListener('change', (event) => {
      if (event.target.matches?.(`input[name="${availability}"]`)) remember(!event.target.checked);
    }, true);
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[is="facet-link"][href]');
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || !isCollection(url)) return;
      if (new URL(window.location.href).searchParams.has(availability) && !url.searchParams.has(availability)) remember(true);
    }, true);
    window.addEventListener('popstate', ensureAvailability);
    ensureAvailability();
  }
})();
